export default {"src":"/_next/static/media/no-image-available.42198c8e.svg","height":84,"width":106,"blurWidth":0,"blurHeight":0};